import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MDBox from 'components/MDBox';
import Card from '@mui/material/Card';
import MDTypography from 'components/MDTypography';

export const DashboardCardWrap = styled(Card)(({ theme, height }) => ({
  display: 'flex',
  position: 'relative',
  borderRadius: '12px',
  height: height || '100%',
  flexDirection: 'column',
  border: '1px solid #f0f2f5',
  boxShadow: '0 8px 16px 0 rgba(0,0,0,0.05)',
}));

export const CardHeaderWrap = styled(MDBox)(({ theme }) => ({
  display: 'flex',
  padding: '12px 16px',
  alignItems: 'center',
  paddingBottom: '0px',
  justifyContent: 'space-between',
  borderBottom: '1px solid #f0f2f5',
}));

export const ScrollableContent = styled(MDBox)(({ theme, height }) => ({
  overflowY: 'auto',
  flex: 1,
  padding: '0px',
  height: height || 'auto',
  '&::-webkit-scrollbar': {
    width: '4px',
  },
  '&::-webkit-scrollbar-thumb': {
    borderRadius: '10px',
    background: '#d1d1d1',
  },
}));

export const ListItemWrap = styled(Box)(({ theme, py }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: `${py || 0.8}rem 16px`,
  borderBottom: '1px solid #f0f2f5',
  transition: 'background-color 0.2s ease',
  '&:last-child': {
    borderBottom: 'none',
  },
  '&:hover': {
    backgroundColor: '#f8f9fa',
  },
}));

export const StatusDot = styled(Box)(({ theme, bgcolor }) => ({
  width: '8px',
  height: '8px',
  flexShrink: 0,
  marginRight: '16px',
  borderRadius: '50%',
  backgroundColor: bgcolor || '#adb5bd',
}));

export const ChartCardWrap = styled(Card)(({ theme }) => ({
  height: '100%',
  padding: '16px',
  display: 'flex',
  textAlign: 'center',
  flexDirection: 'column',
  justifyContent: 'center',
}));

export const StyledStatsCard = styled(Card)(
  ({ theme, bordercolor, variant }) => ({
    height: '100%',
    display: 'flex',
    overflow: 'visible',
    position: 'relative',
    borderRadius: '12px',
    flexDirection: 'column',
    justifyContent: 'center',
    border: '1px solid #f0f2f5',
    boxShadow: '0 8px 16px 0 rgba(0,0,0,0.05)',
    '&:before':
      variant !== 'plain' && bordercolor
        ? {
          top: 0,
          left: 0,
          width: '4px',
          content: '""',
          height: '100%',
          position: 'absolute',
          background: bordercolor,
          borderRadius: '12px 0 0 12px',
        }
        : {},
  }),
);

export const IconWrapper = styled(MDBox)(({ theme, bgcolor }) => ({
  width: '48px',
  height: '48px',
  color: '#fff',
  display: 'flex',
  alignItems: 'center',
  borderRadius: '10px',
  justifyContent: 'center',
  backgroundColor: bgcolor || 'rgba(0, 0, 0, 0.04)',
}));

export const ActionText = styled(MDTypography)({
  cursor: 'pointer',
  fontSize: '11px',
});

export const CalendarTopBox = styled(MDBox)({
  padding: '12px',
  display: 'flex',
  paddingBottom: 0,
  justifyContent: 'center',
});

export const CalendarInnerBox = styled(MDBox)({
  width: '280px',
});

export const CalendarBody = styled(MDBox)({
  flex: 1,
  marginTop: '-16px',
  overflow: 'hidden',
});

export const ChartContainer = styled(MDBox)({
  paddingTop: 0,
  padding: '16px',
});

export const CenteredChartContainer = styled(MDBox)({
  flex: 1,
  paddingTop: 0,
  padding: '16px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});
